import { InputField, Icon, ButtonSelect, Badge } from "@saviynt/design-system";
import { useIntl } from "react-intl";

interface PolicyFilterControlProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  handleFilterClick: () => void;
  isFilterMenuOpen: boolean;
  hasFiltersSelected: boolean;
}

export default function PoliciesFilterControl({
  searchValue,
  onSearchChange,
  handleFilterClick,
  isFilterMenuOpen,
  hasFiltersSelected,
}: PolicyFilterControlProps) {
  const intl = useIntl();

  return (
    <div className="flex flex-1 items-center gap-3" data-name="top row">
      <InputField
        name="searchPolicies"
        placeholder={intl.formatMessage({
          defaultMessage: "Search policies...",
          id: "oWdXZ0",
          description: "Placeholder for search input",
        })}
        kind="search"
        prefixIcon={
          <Icon kind="Search" color="--color-foreground-neutral-subtle" />
        }
        value={searchValue}
        setValue={onSearchChange}
        size="medium"
        classNames={{ container: "flex-1" }}
      />

      <ButtonSelect
        label={intl.formatMessage({
          defaultMessage: "Filter",
          id: "vxq3Bj",
          description: "Label for filter button",
        })}
        onClick={handleFilterClick}
        isOpen={isFilterMenuOpen}
        size="medium"
        prefixIcon={
          <Icon kind="Filter" color="--color-foreground-neutral-subtle" />
        }
        BadgeComp={
          hasFiltersSelected ? (
            <Badge kind="dot" color="primary" size="small" />
          ) : undefined
        }
        dataTestId="NHI-Inventory-Filter"
        aria-expanded={isFilterMenuOpen}
        aria-haspopup="menu"
      />
    </div>
  );
}
